import React from 'react';
import TenderCollection from './TenderCollection';
export default function TenderList() { return <TenderCollection />; }
